import React, { useState, useEffect } from 'react'
import cn from 'classnames'

export default function ShortStats (props) {
  const { stats = {}, fullView = false } = props
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const Row = ({ name, hasIcon = false, value = null, bold = false }) => (
    <div className={cn('calendar-stats-row', { 'bold-text': bold })}>
      {hasIcon && <div className={`indicator-icon ${name}`} />}
      <span>{I18n.t(`calendar.stats.${name}`)}:</span>
      <span>{value || parseFloat(stats[name]) || 0}</span>
    </div>
  )

  return (
    <div className='short-stats'>
      {isMobile && <div className='already-taken-header'>{I18n.t('calendar.stats.used')}:</div>}
      {fullView && !isMobile && <Row name='used' bold value={toParsedValue(stats.used)} />}
      <Row name='planned' hasIcon value={toParsedValue(stats.booked)} />
      <Row name='pending' hasIcon value={toParsedValue(stats.pending)} />
    </div>
  )
}

function toParsedValue (...values) {
  const value = values.reduce((sum, value) => sum + (parseFloat(value || 0) || 0), 0)
  return `${value}`
}
